/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import e from "react";
const i = e.createContext(void 0), c = (t) => {
  const n = e.useRef(null), o = e.useRef(null), r = e.useRef(null), u = e.useMemo(() => ({ actionSheetRef: n, firstViewRef: o, secondViewRef: r }), []);
  return /* @__PURE__ */ e.createElement(i.Provider, { value: u }, t.children);
};
export {
  i as GridColumnMenuAdaptiveContext,
  c as GridColumnMenuAdaptiveProvider
};
